module.exports = __webpack_public_path__ + "media/images/patient-icons/workflow-icon-a389e1ccec952d929613df4108d9d500.svg";